import { CollectionTree } from './collectionTree';

export default CollectionTree;
